module.exports = __webpack_public_path__ + "static/img/8.83f2d23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/8.jpg
// module id = ZNb0
// module chunks = 1